var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangePencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.368 3.29L20.708 5.63C21.098 6.02 21.098 6.65 20.708 7.04L18.878 8.87L15.128 5.12L16.958 3.29C17.148 3.1 17.398 3 17.658 3C17.918 3 18.168 3.09 18.368 3.29ZM2.99805 17.25V21H6.74805L17.808 9.94L14.058 6.19L2.99805 17.25ZM5.91805 19H4.99805V18.08L14.058 9.02L14.978 9.94L5.91805 19Z",
    fill: "#FA7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePencil);
export default __webpack_public_path__ + "static/media/orange_pencil.f26fcb754461425fc11f676771c04040.svg";
export { ForwardRef as ReactComponent };